import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FIREBASE_COLLECTIONS } from "src/app/enums/types.enum";
import { IAppDataItem } from "src/app/interfaces/app-data.interface";
import { AlertService } from "src/app/services/alert/alert.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { SHARED_DATA } from "src/app/shared/shared-data/SHARED_DATA";

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit {
  @Output() onRefetch = new EventEmitter<any>();
  sports: IAppDataItem[] = [];
  areas = [];
  selectedParams: any = {};
  isLoading: boolean = true;
  isSearchClicked: boolean = false;
  inputValue: string = "";

  constructor(
    private storageService: StorageService,
    private alertService: AlertService,
    private firestore: AngularFirestore
  ) {}

  onChange = (param: string, event: any) => {
    this.selectedParams[param] = event.target.value;
  };

  ngOnInit(): void {
    this.bootstrapApplication();
  }

  bootstrapApplication = () => {
    try {
      const item = this.storageService.get("auth");
      if (item?.email && item?.uid) {
        SHARED_DATA.authentication.user = item;
        SHARED_DATA.authentication.isLoggedIn = true;
      }

      this.getAllAppData().subscribe({
        next: (resp: any) => {
          this.storageService.save("__", resp[0]);
          this.isLoading = false;
          this.sports = resp?.[0]?.["sportsCategories"];
          this.sports.push({ id: "0", name: "All" });
          this.sports.sort((a, b) => Number(a.id) - Number(b.id));
        },
        error: (err: any) => {
          this.alertService.show({
            message: "Could not load application's data at this moment",
          });
          this.isLoading = false;
        },
      });
    } catch (error) {
    } finally {
    }
  };

  getAllAppData = () => {
    return this.firestore
      .collection(FIREBASE_COLLECTIONS.APP_DATA)
      .valueChanges();
  };

  onRefetchCourts = () => {
    if (this.selectedParams?.["sportsCategory"] === "All" && !this.inputValue)
      this.storageService.remove("filter");
    this.storageService.save("filter", {
      sportsCategory: this.selectedParams?.["sportsCategory"],
      input: this.inputValue,
    });
    this.selectedParams.input = this.inputValue;
    this.onRefetch.emit(this.selectedParams);
    this.isSearchClicked = true;
  };

  onClearSearch = () => {
    this.storageService.remove("filter");
    // this.onRefetch.emit("");
    // this.isSearchClicked = false;
    window.location.reload();
  };
}
